module.exports = __webpack_public_path__ + "static/media/headshot.3847f745.jpg";